module.exports = __webpack_public_path__ + "static/media/blueFile.053d165b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/blueFile.svg
// module id = 450
// module chunks = 0